import iconsConfig from './icons-config/icons-config'
import colors from './themes'
import { defineVuesticConfig } from 'vuestic-ui'

export default defineVuesticConfig({
  colors,
  icons: iconsConfig,
  breakpoint: {
    enabled: true,
    bodyClass: true,
    thresholds: {
      xs: 0,
      sm: 320,
      md: 640,
      lg: 1024,
      xl: 1440,
    },
  },

  components: {
    VaIcon: {
      sizesConfig: {
        defaultSize: 19,
        sizes: {
          small: 14,
          medium: 19,
          large: 26,
        },
      },
    },
    VaModal: {
      mobileFullscreen: false,
      maxHeight: 'calc(100%)',
    },
    VaPagination: {
      activeButtonProps: {
        preset: 'primary',
      },
    },
    VaDataTable: {
      disableClientSideSorting: true,
    },
    presets: {
      VaButton: {
        usernav: {
          class: 'rounded-full p-0',
          style: '--va-background-color: #FFF; border : 2px solid var(--cm-light);',
        },
        cmdark: {
          class: 'rounded-md font-bold text-white px-4',
          style: '--va-background-color: #101424;',
        },
        cmlight: {
          class: 'text-cm-text',
          iconColor: '#05081A',
          style: '--va-background-color: rgba(255,255,255,0.10); color: var(--cm-text)',
        },
        cmgreen: {
          class: 'rounded-md font-bold text-white px-4',
          iconColor: '#05081A',
          style: '--va-background-color: #2df1d0; color: var(--cm-text)',
        },
        cmpurple: {
          class: 'rounded-md font-bold text-white px-4',
          iconColor: '#05081A',
          style: '--va-background-color: #9848fc;  color: var(--cm-text); border: 2px solid var(--cm-text)',
        },
        cmoutline: {
          class: 'text-cm-text pl-8 pr-8 pt-1 pb-1 ',
          iconColor: '#05081A',
          style: '--va-background-color: rgba(255,255,255,0);  color: var(--cm-text); border: 2px solid var(--cm-text)',
        },
        customernav: {
          class: 'text-cm-black rounded-full',
          style: '--va-background-color: #FFF; border : 2px solid var(--cm-light);',
        },
      },
      VaSelect: {
        small: {
          class: 'va-select--small',
          keepAnchorWidth: false,
          placement: 'bottom-end',
          width: 'min(100%, 150px)',
          style:
            '--va-input-wrapper-min-height: 24px; --va-input-wrapper-border-radius: 2px; --va-input-wrapper-width: 100px;',
        },
      },
    },
  },
})
